import { IPaymentMethod, RootState } from '@checkout/state';
import { ChangeEvent } from 'react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { paymentMethodChangeRequest } from '../../../reducers/checkout';
import { renderKlarnaPaymentTermsLink } from '../../../utils/klarnaTerms';
import { GroupTitle, MessageBox, RadioGroup } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './PaymentOptions.scss';

interface IOwnProps {
  onSubmit?: any;
  displayDirection?: 'row' | 'column';
}

interface IConnectedProps {
  paymentMethods: IPaymentMethod[];
  grandTotalPrice: string;
  selectedPaymentMethod: string;
}

interface IConnectetDispatchProps {
  paymentMethodChangeRequest: typeof paymentMethodChangeRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class PaymentOptions extends React.Component<Props, {}> {

  handlePaymentOptionChange = (event: ChangeEvent<any>) => {
    this.props.paymentMethodChangeRequest({ paymentMethod: event.target.value });
  }

  componentDidMount() {
    renderKlarnaPaymentTermsLink(this.props.paymentMethods);
  }

  render() {
    const { displayDirection, paymentMethods, selectedPaymentMethod, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className={Styles.formContent}>
        <GroupTitle title={formatMessage(messages.payment_group_title)} accent={true} variant="big" />
        <RadioGroup
          blockFor="PaymentMethods"
          displayDirection={displayDirection}
          options={paymentMethods}
          selectedOption={selectedPaymentMethod}
          groupName="paymentMethod"
          onChange={this.handlePaymentOptionChange}
        />
        <CheckoutContextConfig.Consumer>
          {(checkoutContextConfig => (
            checkoutContextConfig.ui.paymentMethodDescriptions &&
            checkoutContextConfig.ui.paymentMethodDescriptions.enabled &&
            checkoutContextConfig.ui.paymentMethodDescriptions.descriptions[selectedPaymentMethod] && (
              <MessageBox
                type="info"
                spacingTop={true}
                message={checkoutContextConfig.ui.paymentMethodDescriptions.descriptions[selectedPaymentMethod]}
              />
            )
          ))}
        </CheckoutContextConfig.Consumer>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  paymentMethods: state.checkout.paymentMethods,
  grandTotalPrice: state.checkout.selection.totals.grandTotalPrice,
  selectedPaymentMethod: state.checkout.selection.paymentMethod,
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {
      paymentMethodChangeRequest,
    },
  )
)(PaymentOptions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PaymentOptions/PaymentOptions.tsx